import { useNavigate } from 'react-router-dom';
import { PlusCircle, List, UserPlus } from 'lucide-react';
import { CONFIG } from '../../lib/config';
import { useUserStore } from '../../lib/userStore';
import { useLanguageStore } from '../../lib/languageStore';
import { translate } from '../../lib/translations';
import { usePageTracking } from '../../lib/hooks/usePageTracking';

export function LeagueDashboard() {
  // Tracker cette page
  usePageTracking('landingpage');

  const navigate = useNavigate();
  const username = useUserStore((state) => state.username);
  const { language } = useLanguageStore();
  const isArsenal = CONFIG.enableArsenalMode;

  return (
    <div className="row justify-content-center">
      <div className="col-12 col-lg-8">
        <div className="card shadow-lg border-0 glass-effect hover-lift">
          <div className="card-body p-5">
            <div className="text-center mb-5">
              <h1 className="display-4 fw-bold text-gradient mb-3">
                {translate('hockey.dynasty.dashboard', language)}
              </h1>
              <p className="lead text-muted mb-0">
                {translate('welcome.user', language, { username: username || '' })}
              </p>
            </div>
            
            <div className="d-grid gap-4">
                {/* Arsenal mode: montrer aussi "Créer une ligue" et "Mes ligues" */}
                <button
                  className="btn btn-primary btn-lg p-4 d-flex align-items-center justify-content-center gap-3 position-relative overflow-hidden"
                  onClick={() => navigate('/create-league')}
                  style={{
                    fontSize: '1.1rem',
                    fontWeight: '601',
                    borderRadius: '1rem'
                  }}
                >
                  <PlusCircle size={28} />
                  <span>{translate('create.new.league', language)}</span>
                </button>

                <button
                  className="btn btn-primary btn-lg p-4 d-flex align-items-center justify-content-center gap-3 position-relative overflow-hidden"
                  onClick={() => navigate('/select-league')}
                  style={{
                    fontSize: '1.1rem',
                    fontWeight: '601',
                    borderRadius: '1rem'
                  }}
                >
                  <List size={28} />
                  <span>{translate('select.my.league', language)}</span>
                </button>

                <button
                  className="btn btn-primary btn-lg p-4 d-flex align-items-center justify-content-center gap-3 position-relative overflow-hidden"
                  onClick={() => navigate('/join-league')}
                  style={{
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    borderRadius: '1rem'
                  }}
                >
                  <UserPlus size={28} />
                  <span>{translate('join.league', language)}</span>
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}